import {
  searchNavigationActivity,
  searchNavigationProduct,
} from "@/api";
import { initTime } from "@/utils/countdown";
import { platform } from "@/utils/platform";
import Track from "@/utils/track";
import { getUrlParam } from "@/utils/url-parse";
import { useRef, useState } from "react";
import { pxtorem } from "../../../../../utils/pxtorem";
import { ActivityItem, DataInfo, ProductItem, } from "../types/index";
export const useDataHook = ({
    cpntData,
    pageData,
    last=false,
  }) => {
    const urlParams=getUrlParam();
    const [activeTab1Index, setActiveTab1Index] = useState(0);
    const [activeTab2Index, setActiveTab2Index] = useState(0);
    
  
    let [tabOptps, setTabOptps] = useState(JSON.parse(JSON.stringify(cpntData)));
    const [hasMore, setHasMore] = useState(false);
    const lockRef = useRef(false);
    
    // 是否没有任何导航tabs数据，理论上不会，除非配错了
    const [isAllEmpty, setIsAllEmpty] = useState(false);
    const track = Track();
  
    const activeTab1 = tabOptps?.navigationConfigDetails[activeTab1Index] || {};
  
    const activeTab2 = activeTab1?.childNavigationConfigDetails?.[activeTab2Index] || {};
    // const activeTab2 = tabOptps?.navigationConfigDetails[activeTab1Index]?.childNavigationConfigDetails?.[activeTab2Index] || {};
  
    console.error("activeTab2",activeTab2);
    // 下一条数据的索引
    const fromIndex=activeTab2.dataInfo?.result?.length ?? 0;



    // 格式档期时间，可能是预告倒计时
    const changeTime = (activityRspData: DataInfo | undefined) => {
      for (const item of (activityRspData?.result as ActivityItem[]) || []) {
        const { day, hour, minute, seconds } = initTime({
          type: "ms",
          startTime: item?.status === 1 ? new Date(item?.beginTimeStr || "").valueOf() : new Date(item?.endTimeStr || "").valueOf(),
          serverTime: new Date().valueOf(),
        });
        item.day = Number(day);
        item.hour = Number(hour);
        item.minute = Number(minute);
        item.seconds = Number(seconds);
      }
    };
  
  
    /**
     * 切换一级tab
     * @param targetTab1Index 一级tab的下标
     */
    const changeActiveKey = (targetTab1Index: number) => {
      if (targetTab1Index === activeTab1Index) {
        return;
      }
      setActiveTab1Index(targetTab1Index);
      // 切换一级tab时，二级tab索引重置为0
      setActiveTab2Index(0);
      setHasMore(true);

      // 横向导航滚动逻辑
      if (tabOptps?.styleType === "0" && tabOptps?.navigationType === "HORIZONTAL") {
        const id = `${tabOptps?.navigationConfigDetails[activeTab1Index].componentDetailCode}-content`;
        const navId = `${tabOptps?.navigationConfigDetails[activeTab1Index].componentDetailCode}-content`;
        const dom = document.getElementById(navId) as HTMLElement | null;
        const domContent = document.getElementById(id) as HTMLElement | null;
        const pageDom = document.getElementById("page") as HTMLElement | null;
        if (
          (platform.isH5 || platform.isWxH5) &&
          pxtorem(dom?.getBoundingClientRect()?.top ?? 0) <= pxtorem(97)
        ) {
          if (pageDom && domContent) {
            pageDom.scrollTop = domContent.offsetTop - 96;
          }
        }
        if ((dom?.getBoundingClientRect()?.top ?? 0) <= 0) {
          if (pageDom && domContent) {
            pageDom.scrollTop = domContent.offsetTop - 50;
          }
        }
      }
      
      
      const currentNav = tabOptps?.navigationConfigDetails[targetTab1Index] || {};
      track.track("tab_click", {
        page_name: document.title,
        tab_name: currentNav.tabName,
        rank: targetTab1Index,
        market_id: urlParams?.["customPageCode"],
        market_name: document.title,
      });
    };
  

    /**
     * 切换二级tab
     * @param childIndex 二级tab的key
     */
    const changeActiveChildKey = async (targetTab2Index: number) => {
      if(activeTab2Index === targetTab2Index){
        return;
      }
      const targetTab2 = activeTab1?.childNavigationConfigDetails?.[targetTab2Index] || {};

      track.track("tab_click", {
        page_name: document.title,
        tab_name: targetTab2.tabName,
        rank: targetTab2.tabName,
        market_id: urlParams?.["customPageCode"],
        market_name: document.title,
      });

      setActiveTab2Index(targetTab2Index);
    };

    /**
     * 获取档期
     * @param isScroll 是否是滚动加载
     * @returns 
     */
    const queryActivity = async () => {
      if(lockRef.current){
        return;
      }
      try {
        
        // 下一条数据的索引
        const fromIndex=activeTab2.dataInfo?.result?.length ?? 0;
        const params = {
          componentCode: tabOptps.componentCode,
          componentDetailCode: activeTab1.componentDetailCode,
          childComponentDetailCode: activeTab2.componentDetailCode || "",
          customPageCode: pageData?.pageCode,
          customPageVersion: pageData?.version,
          from:fromIndex,
          pageSize: fromIndex > 0 ? activeTab2.morePageSize : activeTab2.pageSize,
          lastActivityId:
            (activeTab2?.dataInfo?.result?.length ?? 0) > 0
              ? activeTab2?.dataInfo?.extra?.lastActivityId
                ? activeTab2?.dataInfo?.extra?.lastActivityId
                : (activeTab2?.dataInfo?.result[(activeTab2?.dataInfo?.result?.length ?? 1) - 1] as ActivityItem)?.activityId
              : null,
          pageId: "H5_SuperMarketing",
        };
        lockRef.current = true;
        const res = await searchNavigationActivity(params);
        lockRef.current = false;
        if (res?.data) {
          //格式化档期时间
          changeTime(res?.data);
          const newTabOptps = { ...tabOptps };
          const targetTab2 = newTabOptps.navigationConfigDetails[activeTab1Index].childNavigationConfigDetails[activeTab2Index];
          targetTab2.dataInfo = {
            ...res?.data,
            result:  [
              ...(targetTab2.dataInfo?.result || []),
              ...(res.data?.result || [])
            ] 
          };

          if (last) {
            setHasMore(res?.data?.hasNext ?? false);
          }

          setTabOptps(newTabOptps);
        }
      } catch (error) {
        console.error(error);
        lockRef.current = false;
      }
    };
  
    //获取商品
    const queryProduct = async () => {
      if(lockRef.current){
        return;
      }
      try {
  
        const params = {
          componentCode: tabOptps.componentCode,
          componentDetailCode: activeTab1.componentDetailCode,
          childComponentDetailCode: activeTab2.componentDetailCode || "",
          customPageCode: pageData?.pageCode,
          customPageVersion: pageData?.version,
          from: fromIndex,
          pageSize: fromIndex > 0 ? activeTab2.morePageSize : activeTab2.pageSize,
          lastActivitySpuCode:
            (activeTab2?.dataInfo?.result?.length ?? 0) > 0
              ? activeTab2?.dataInfo?.extra?.lastActivitySpuCode
                ? activeTab2?.dataInfo?.extra?.lastActivitySpuCode
                : (activeTab2?.dataInfo?.result[(activeTab2?.dataInfo?.result?.length ?? 1) - 1] as ProductItem)?.activitySpuId
              : null,
          pageId: "H5_SuperMarketing",
          preview: false,
        };
        lockRef.current = true;
        const res = await searchNavigationProduct(params);
        lockRef.current = false;
        if (res?.data) {
          const newTabOptps = { ...tabOptps };
          const targetTab2 = newTabOptps.navigationConfigDetails[activeTab1Index].childNavigationConfigDetails[activeTab2Index];
          targetTab2.dataInfo = {
            ...res?.data,
            result:  [
              ...(targetTab2.dataInfo?.result || []),
              ...(res.data?.result || [])
            ] 
          };

          if (last) {
            setHasMore(res?.data?.hasNext ?? false);
          }
          setTabOptps(newTabOptps);
        }
      } catch (error) {
        console.error(error);
        lockRef.current = false;
      }
    };
  
    //加载更多档期
    const loadMoreActivity = async () => {
      track.track("btn_click", {
        page_name: document.title,
        module: "普通导航档期",
        btn_name: "查看更多",
        btn_text: "查看更多",
      });
      await queryActivity();
    };
  
    //商品加载更多
    const loadMoreProduct = async (item: number, isScroll = false) => {
      track.track("btn_click", {
        page_name: document.title,
        module: "普通导航商品",
        btn_name: "查看更多",
        btn_text: "查看更多",
      });
      await queryProduct();
    };
  
  
    // 加载更多
    const loadMore = async () => {
      if (activeTab2.type === "ACTIVITY") {
        loadMoreActivity();
        return;
      }
      loadMoreProduct(activeTab1Index, true);
    };


    return {
        tabOptps,
        setTabOptps,
        activeTab1Index,
        activeTab1,
        activeTab2Index,
        activeTab2,
        hasMore,
        isAllEmpty,
        setIsAllEmpty,
        lockRef,
        fromIndex,
        changeActiveKey,
        changeActiveChildKey,
        loadMore,
        queryActivity,
        queryProduct,
        loadMoreActivity,
        loadMoreProduct,
        changeTime,
    };
};

